'use client'

import Pagenation from "@/components/common/pagenation";
import Tabs from "@/components/etc/tab";
import PageBanner from "@/components_mobile/banner/page_banner";
import { BannerContext } from "@/context/bannerContext";
import { PageTitleContext } from "@/context/pageTitleContext";
import { BoardViewTypes, searchQueryStringTypes, searchQueryStringTypesDefault } from "@/type/list";
import { tabsType } from "@/type/page";
import api from "@/util/api";
import getQueryString from "@/util/queryString";
import { usePathname, useSearchParams, useRouter } from "next/navigation";
import { createContext, ReactNode, useContext, useEffect, useRef, useState } from "react";
import Search from "@/app/event/_search"

import Lottie from "react-lottie-player";
import loadingJson from "@/public/media/load_data.json"
import BoardView from "@/components/board/view";
import CommentList from "@/components/board/coment";
import { AuthContext } from "@/context/authContext";
import { getLast, getLastTwo } from "@/util/util";
import { SignContext } from "@/context/signContext";
import { DeviceContext } from "@/context/deviceContext";
import { useTranslations } from "next-intl";

interface communityQueryStringTypes extends searchQueryStringTypes {
    cate: number
}
interface communityTabsTypes extends tabsType {
    cate: number
}
export const CommunityListContext = createContext<{
    list: any[]
    selectContent: any
    setContent: (id: number) => void
    editCategory: number
}>({
    list: [],
    selectContent: undefined,
    setContent: () => { },
    editCategory: 2
})

export default function CommunityConfig({ children }: { children: ReactNode }) {
    const { pageTitle, SetPageTitle } = useContext(PageTitleContext)
    const { page_top_banner } = useContext(BannerContext)
    const { user } = useContext(AuthContext)
    const { mobileMode } = useContext(DeviceContext)

    const isFirstRender = useRef(true)
    const [loading, setLoading] = useState<boolean>(false)

    const [list, setList] = useState<any[]>([])
    const [selectContent, setSelectContent] = useState<BoardViewTypes>()
    const [totalCount, setTotalCount] = useState<number>(1)
    const [thispage, setPage] = useState<number>(1)
    const perPage = mobileMode ? 10 : 20;

    const [editAuth, setEditAuth] = useState<boolean>(false)
    const [writeAuth, setWriteAuth] = useState<boolean>(false)
    const [editCategory, setEditCategory] = useState<number>(1)

    const [queryString, setQueryString] = useState<communityQueryStringTypes>()

    const pathName = usePathname()
    const searchParams = useSearchParams()
    const router = useRouter()

    const p = useTranslations("PageTitle")

    function setContent(viewId: number) {
        router.push(pathName as string + `?id=${viewId}`)
        const selectCountent: any = list.find((el) => el.id == viewId)
        setSelectContent(selectCountent)
    }

    function fetchData() {
        if (!queryString) return;
        if (queryString.cate) {
            const thisPage = tabs_path.find((el) => el.path == pathName)
            queryString.cate = thisPage?.cate || 1
        }
        if (!mobileMode) {
            queryString.page_count = 20
        }
        const apiUrl = `/api/community/` + getQueryString(queryString)
        api(apiUrl)
            .then(res => res.json())
            .then(({ data }) => {
                setList(data?.posts_list ?? [])
                setTotalCount(data?.total_count ?? 1)
            })
    }

    const tabs_path: communityTabsTypes[] = [
        { name: "스포츠 뉴스", path: "/community/sports/", cate: 1 },
        { name: "회원분석", path: "/community/users/", cate: 2 },
        { name: "자유게시판", path: "/community/free/", cate: 3 },
        { name: "업체뉴스", path: "/community/toto/", cate: 4 },
    ]


    useEffect(() => {
        const thisPage = tabs_path.find((el) => el.path == pathName)
        if (thisPage) {
            SetPageTitle(thisPage.name)
        } else {
            SetPageTitle(tabs_path[0].name)
        }

        const thisPageType = tabs_path.find(el => el.path == pathName)
        if (thisPageType) {
            setEditCategory(thisPageType.cate)
        }
        setQueryString({ ...searchQueryStringTypesDefault, cate: thisPage?.cate || 1 })
    }, [pathName])

    useEffect(() => {
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        };

        const newQueryString: communityQueryStringTypes = {
            search_type: "",
            keyword: "",
            page: thispage,
            page_count: perPage,
            cate: queryString?.cate || 1
        }
        setQueryString(newQueryString)
    }, [thispage])


    useEffect(() => {
        if (!list || list.length === 0) return;
        const id = searchParams?.get('id');

        if (id) {
            const getContent = list.find((el) => String(el.id) === id);
            setSelectContent({ ...getContent, viewType: 'comm' });
        } else {
            setSelectContent(undefined);
        }
        setLoading(false)
    }, [searchParams, list]);

    useEffect(() => {
        fetchData()
    }, [queryString])

    useEffect(() => {
        if (!user.is_authenticated) return;

        let writeAuth = false
        let editAuth = false

        // 일반유저 체크
        switch (editCategory) {
            case 2:
            case 3:
                // 회원분석, 자유게시판
                writeAuth = true
                break;
        }
        if (selectContent?.is_author === true || (user.is_authenticated && user.is_admin === true)) {
            editAuth = true
        }
        setWriteAuth(writeAuth)
        setEditAuth(editAuth)
    }, [user, queryString])

    useEffect(() => {
        if (!queryString) return;
        // 서버 갱신(=refresh) 후 무조건 다시 데이터 가져오기
        setLoading(true)
        fetchData()
    }, [pathName, searchParams])

    if (!queryString) return null;
    return (
        <div>
            <PageBanner bannerMap={mobileMode ? page_top_banner.get(76) : page_top_banner.get(36)} />
            <div className="page-title">{p(pageTitle)}</div>
            <Tabs tabs_path={tabs_path} />
            <CommunityListContext.Provider value={{ list, selectContent, setContent, editCategory }}>
                {
                    loading
                        ? <>
                            <BoardView selectContent={selectContent}
                                setSelectContent={setSelectContent}
                                post="/api/community/edit/"
                                writeAuth={writeAuth}
                                editAuth={editAuth}
                                fetchData={fetchData} />
                            <Search totalCount={totalCount} queryString={queryString} setQueryString={setQueryString} addQuery={{ cate: queryString.cate }} />
                            {children}
                            <Pagenation totalCount={totalCount} perPage={queryString.page_count} setPage={setPage} />
                        </>
                        : <Lottie loop animationData={loadingJson} play style={{ maxWidth: `400px`, margin: "0 auto" }} />
                }
            </CommunityListContext.Provider>
        </div>
    )
}